// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__2zeGs","Success":"Button_Success__3EgOl","Danger":"Button_Danger__3i_hm"};